"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const fa_1 = require("react-icons/fa");
const Button_1 = __importDefault(require("../../elements/Button"));
const ToggleButton_1 = __importDefault(require("../../elements/ToggleButton"));
const PanelHeader_1 = __importDefault(require("./PanelHeader"));
const PreferencesButton_1 = require("../../elements/PreferencesButton");
const CounterLabel_1 = require("../../elements/CounterLabel");
const styles = {
    leftContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex: 1,
    },
};
function createFilterLabel(total, counter) {
    if (typeof counter === 'boolean') {
        return `[ ${total || 0} ]`;
    }
    return `[ ${counter}/${total} ]`;
}
exports.createFilterLabel = createFilterLabel;
function DefaultPanelHeader({ counter, counterLabel, onDelete = () => null, deleteToolTip = 'Delete', onFilter = () => null, filterToolTip = '', children, onSettingClick = () => null, showSettingButton = false, canDelete = true, disableDelete = false, style = {}, className = '', renderRightButtons, }) {
    return ((0, jsx_runtime_1.jsxs)(PanelHeader_1.default, { style, className, children: [(0, jsx_runtime_1.jsxs)("div", { style: styles.leftContainer, children: [canDelete && ((0, jsx_runtime_1.jsx)(Button_1.default.BarButton, { color: { base: 'black', hover: 'red' }, onClick: onDelete, disabled: counter === 0 || disableDelete, toolTip: deleteToolTip, tooltipOrientation: "horizontal", children: (0, jsx_runtime_1.jsx)(fa_1.FaRegTrashAlt, {}) })), filterToolTip ? ((0, jsx_runtime_1.jsx)(ToggleButton_1.default, { popupTitle: filterToolTip, popupPlacement: "right", onClick: onFilter, children: (0, jsx_runtime_1.jsx)(fa_1.FaFilter, { style: { pointerEvents: 'none', fontSize: '12px' } }) })) : null, children] }), renderRightButtons?.(), counterLabel && (0, jsx_runtime_1.jsx)(CounterLabel_1.CounterLabel, { children: counterLabel }), showSettingButton && (0, jsx_runtime_1.jsx)(PreferencesButton_1.PreferencesButton, { onClick: onSettingClick })] }));
}
exports.default = DefaultPanelHeader;
